import type {MouseEventHandler} from 'react';
import React from 'react';
import './icon-box.scss';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import styles from './icon-box.module.scss';

export interface IconBoxProps {
  /**
   * Should be one of the postermaker icon classes
   */
  icon: string;
  ariaLabel?: string;
  /**
   * Additional classes to give to the button
   */
  className?: string;
  iconClass?: string;
  /**
   * Id to give to the button
   */
  id?: string;
  isSelected?: boolean;
  selectionStyle?: string;
  disabled?: boolean;
  /**
   * Handler for when mouse is clicked
   */
  onClick?: MouseEventHandler;
  size?: IconBoxSize;
  /**
   * Text at the bottom to show
   */
  text?: string;
  /**
   * text to show on hover
   */
  title?: string;
  iconSize?: IconSize;
}

export enum IconBoxSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export enum IconSelectionStyle {
  DEFAULT = 'default',
  TYPE_1 = 'type_1',
}

export function IconBox({
  icon,
  size = IconBoxSize.MEDIUM,
  iconSize = IconSize.SIZE_ICON_24,
  id = '',
  className = '',
  iconClass = '',
  text = '',
  disabled = false,
  isSelected = false,
  selectionStyle = IconSelectionStyle.DEFAULT,
  onClick = $.noop,
  ...props
}: IconBoxProps) {
  const getSelectionClass = () => {
    switch (selectionStyle) {
      case IconSelectionStyle.TYPE_1:
        return styles.type1;

      default:
        return '';
    }
  };

  const classes = [
    IconBoxSize,
    className,
    disabled ? styles.disabled : '',
    styles.container,
    isSelected && !disabled ? `${styles.btnSelected} body-sm-bold` : 'body-sm-regular',
    getSelectionClass(),
  ];

  const onButtonClick = (e: React.MouseEvent) => {
    onClick(e);
  };

  return (
    <button id={id} className={classes.join(' ')} disabled={disabled} onClick={onButtonClick} title={props.title} aria-label={props.ariaLabel}>
      <Icon icon={icon} className={`${styles.icon} ${iconClass}`} size={iconSize} isDisabled={disabled} />
      <Text size={TextSize.XXSMALL} val={text} className={styles.label} />
    </button>
  );
}
